import Vue from "vue"
const VueClipboard = require("vue-clipboard2")

Vue.use(VueClipboard)
